export default __webpack_public_path__ + "styles/quantecon-book-theme.css";